export class JobProgressStepSnapshotCreationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "reEncrypted",
            "baseName": "reEncrypted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "usedCustomerManagedKey",
            "baseName": "usedCustomerManagedKey",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "allocatedStorageGib",
            "baseName": "allocatedStorageGib",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineVersion",
            "baseName": "engineVersion",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepSnapshotCreationData.attributeTypeMap;
    }
    constructor() {
    }
}
